import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      component: Layout,
      redirect: '/',
      children: [
        {
          path: '/',
          component: (resolve) => require(['@/views/home'], resolve),
          name: 'index',
          meta: { title: '首页', icon: 'dashboard', affix: true }
        },
        {
          path: '/introduction',
          component: (resolve) => require(['@/views/introduction'], resolve),
          name: 'Introduction',
          meta: { title: '大赛介绍', icon: 'dashboard', affix: true }
        },
        {
          path: '/dynamic',
          component: (resolve) => require(['@/views/dynamic'], resolve),
          name: 'Dynamic',
          meta: { title: '赛事动态', icon: 'dashboard', affix: true }
        },
        {
          path: '/scoreQuery',
          component: (resolve) => require(['@/views/scoreQuery'], resolve),
          name: 'ScoreQuery',
          meta: { title: '证书查询', icon: 'dashboard', affix: true }
        },
        {
          path: '/certificateQuery',
          component: (resolve) => require(['@/views/certificateQuery'], resolve),
          name: 'CertificateQuery',
          meta: { title: '证书查询', icon: 'dashboard', affix: true }
        },
        {
          path: '/signUp',
          component: (resolve) => require(['@/views/signUp'], resolve),
          name: 'SignUp',
          meta: { title: '报名中心登录', icon: 'dashboard', affix: true },
        },
        {
          path: '/personal',
          component: (resolve) => require(['@/views/personal'], resolve),
          name: 'Personal',
          meta: { title: '注册', icon: 'dashboard', affix: true },
        },
        {
          path: '/password',
          component: (resolve) => require(['@/views/password'], resolve),
          name: 'Password',
          meta: { title: '找回密码', icon: 'dashboard', affix: true },
        },
        {
          path: '/registrationCenter',
          component: (resolve) => require(['@/views/registrationCenter'], resolve),
          name: 'RegistrationCenter',
          meta: { title: '报名信息', icon: 'dashboard', affix: true },
        },
        {
          path: '/information',
          component: (resolve) => require(['@/views/information'], resolve),
          name: 'Information',
          meta: { title: '报名信息', icon: 'dashboard', affix: true },
        },
        {
          path: '/preliminaryWorks',
          component: (resolve) => require(['@/views/preliminaryWorks'], resolve),
          name: 'PreliminaryWorks',
          meta: { title: '初赛作品', icon: 'dashboard', affix: true },
        },
        {
          path: '/memberInformation',
          component: (resolve) => require(['@/views/memberInformation'], resolve),
          name: 'MemberInformation',
          meta: { title: '成员信息', icon: 'dashboard', affix: true },
        },
        {
          path: '/changePassword',
          component: (resolve) => require(['@/views/changePassword'], resolve),
          name: 'ChangePassword',
          meta: { title: '修改密码', icon: 'dashboard', affix: true },
        },
        {
          path: '/flowPath',
          component: (resolve) => require(['@/views/flowPath'], resolve),
          name: 'FlowPath',
          meta: { title: '竞赛流程', icon: 'dashboard', affix: true },
        },
        {
          path: '/inviteMembers',
          component: (resolve) => require(['@/views/inviteMembers'], resolve),
          name: 'InviteMembers',
          meta: { title: '邀请成员', icon: 'dashboard', affix: true },
        },

      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js